import React, { useState, useEffect } from "react";
import axiosInstance from "../../axiosInstance";
import { toast } from "react-toastify";
import '../../styles/ScopePopup.css'

const ScopePopup = ({ closePopup, editData, triggerReload }) => {
  // Form field states
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (editData?.id) {
      const fetchData = async () => {
        try {
          const response = await axiosInstance.get(`/costsolution/scope/get/${editData.id}`);
          setCode(response.data.scopes.code || "");
          setName(response.data.scopes.name || "");
          setIsEditing(true);
        } catch (error) {
          toast.error("Failed to fetch scope details");
          console.error("Fetch error:", error);
        }
      };
      fetchData();
    }
  }, [editData?.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const postData = { code, name };

    try {
      const url = isEditing 
        ? `/costsolution/scope/${editData?.id}`
        : '/costsolution/scope';

      const method = isEditing ? 'put' : 'post';

      const response = await axiosInstance[method](url, postData);

      toast.success(isEditing ? "Scope updated successfully!" : "Scope created successfully!");
      triggerReload(); 
      closePopup();
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to save scope");
      console.error("Save error:", error);
    }
  };
  
  const handleClear = () => {
    setCode("");
    setName("");
  };
  
  return (
      <div className="scope-creation-popup-overlay">
        <div className="scope-creation-popup-container">
          {/* Close Button */}
          <div className="scope-creation-popup-header">
            <h2>{isEditing ? 'Edit Scope' : 'Create New Scope'}</h2>
            <button className="close-button" onClick={closePopup}>×</button>
          </div>

          <form onSubmit={handleSubmit}>
          <div className="scope-creation-popup-body">
            <div className="scope-creation-form-group">
              <label>Code</label>
              <input
                type="text"
                id="code"
                name="code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                required
                style={{margin:'0px'}}
              />
            </div>

            <div className="scope-creation-form-group">
              <label htmlFor="category" className='name'>Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                style={{margin:'0px'}}
              />
            </div>
          </div>
         
          <div className="scope-creation-popup-footer">
            <button type="button" className='scope-clear-button' onClick={handleClear}>Clear</button>
            <button className="scope-submit-button" onClick={handleSubmit}>
              {isEditing ? 'Update' : 'Submit'}
            </button>
          </div>
          </form>
        </div>
      </div>
  );
}

export default ScopePopup;